const FORMAT_NAME_OVERRIDES = {
  // excessUnmetThermalEnergy: "Excess/Unmet Thermal Energy",
};

export const formatName = (name) => {
  if (!name) return name;
  if (FORMAT_NAME_OVERRIDES[name]) return FORMAT_NAME_OVERRIDES[name];
  // Replace any occurrence of 'battery' (case-insensitive) with 'BESS'
  // Then insert spaces for camelCase / acronym boundaries and normalize spacing
  let s = name.replace(/battery/ig, "BESS");
  // Convert underscores/dashes to spaces
  s = s.replace(/[_-]+/g, " ");
  // Insert space between lower->Upper (camelCase)
  s = s.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
  // Insert space between an uppercase acronym and following Capitalized word (e.g., BESSLoss -> BESS Loss)
  s = s.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
  s = s.replace(/\s+/g, " ").trim();
  // Capitalize first letter of each word (keeps 'BESS' uppercase)
  s = s.replace(/\b\w/g, (m) => m.toUpperCase());
  return s;
};

export const ROSETTE_OUTER_CIRCLE_COLORS = {
  Load: "#E47F00",
  Utility: "#42B4E6",
  PV: "#009530",
  Battery: "#3DCD58",
  Genset: "#24B43F",
  EVCS: "#E47F00",
};

export const generateSections = (metrics, props) => {
  return Object.entries(metrics)?.map(([subKey, subValue]) => ({
    value: 100,
    color: ROSETTE_OUTER_CIRCLE_COLORS[props?.name],
    // tooltip: `${formatName(subKey)} ( ${parseFloat(subValue)} MWh )`,
  }));
};

export const ROSETTE_ICONS = {
  Load: "lighting",
  Utility: "segment_energy_infrastructure",
  PV: "solar_panel1",
  Battery: "battery2_general",
  Genset: "genset_01",
  Evcs: "electric_vehicle_terminal",
};

export const ENERGY_BALANCE_LABELS = [
  { name: "selfConsumption", symbol: "%" },
  { name: "savings", symbol: "$" },
  { name: "energy", symbol: "$" },
  { name: "demandCharge", symbol: "$" },
  { name: "unmetHours", symbol: "h" },
  { name: "unmetEnergyConnected", symbol: "MWh" },
  { name: "unmetEnergyOffgrid", symbol: "MWh" },
  { name: "excessEnergyConnected", symbol: "MWh" },
  { name: "excessEnergyOffgrid", symbol: "MWh" },
  // { name: "excessUnmetThermalEnergy", symbol: (<span>MWh<sub> th</sub></span>) },
];
